import * as React from 'react';
import { withStyles, WithStyles, createStyles, Theme } from '@material-ui/core/styles';
// import Typography from '@material-ui/core/Typography';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import logo from '../ags_logo_white.png';
import Facebook from './Icons/facebookIcon';
import Twitter from './Icons/twitterIcon';
import Instagram from './Icons/instagramIcon';
import Linkedin from './Icons/linkedinIcon';

const jss = (theme: Theme) => createStyles({
    title: {
        paddingLeft: 10,
        flex: '1 1 auto',
    },
    footer: {
        position: 'relative',
    },
    footerToolbar: {
        justifyContent: 'center',
        maxWidth: 1200,
        margin: '0px auto',
        height: 120,
    },
    footerLogo: {
        height: 80,
        width: 'auto',
    },
    link: {
        color: theme.palette.primary.contrastText,
    },
    icon: {
        height: '20px',
        width: '20px',
        margin: '5px',
    }
});

interface Props extends WithStyles<typeof jss> {}

export class Footer extends React.Component<Props, {}> {
    render() {
        const { classes } = this.props;
        return (
            <AppBar className={classes.footer}>
                <Toolbar className={classes.footerToolbar}>
                    <img src={logo} alt="AGS" className={classes.footerLogo} />
                    {/* <Typography className={classes.title} variant="subheading" color="inherit" align="left">
                    </Typography> */}
                    <a href="https://www.facebook.com/americangeo/" className={classes.link} target="_blank">
                        <Facebook className={classes.icon} />
                    </a>
                    <a href="https://twitter.com/americangeo" className={classes.link} target="_blank">
                        <Twitter className={classes.icon} />
                    </a>
                    <a href="https://www.instagram.com/american_geo/" className={classes.link} target="_blank">
                        <Instagram className={classes.icon} />
                    </a>
                    <a href="https://www.linkedin.com/company/american-geographical-society/" className={classes.link} target="_blank">
                        <Linkedin className={classes.icon} />
                    </a>
                </Toolbar>
            </AppBar>
        );
    }
}

export default withStyles(jss)(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer.tsx